import { EMPLOYEES_CREDIT_DATA } from '../actions';

const INIT_STATE = {
    tmpSubproducto: null,
    credit: {
        id: null,
        fecha_creacion: null,
        banco: null,
        ciudad_banco: null,
        tipo_credito: null,
        tipo_cuenta: null,
        responsable: null,
        monto: null,
        plazo: null,
        total_cuota: null,
    },
    client: {
        id: null,
        numero_identificacion: null,
        nombres: '',
        primer_nombre: '',
        primer_apellido: '',
        tipo_identificacion: null,
    },
    calculator: {},
};

const creditEmployeesReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case EMPLOYEES_CREDIT_DATA:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export default creditEmployeesReducer;
